import { AxiosResponse } from "axios";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { api } from "../base/api";
import { Result } from "@/main/models/common/resultResponse";
import { IPartBrandApi } from "@/main/api/base/registration/partBrandApi";
import { TireBrandRequest, TireBrandSaveRequest } from "@/main/models/request/tireBrandRequest";
import { TireBrandResponse } from "@/main/models/response/tireBrandResponse";
import { KeyValue } from "@/main/models/common";

const baseRoute: string = "PartBrand";

export class PartBrandApi extends IPartBrandApi {
	getDomain(idBrandType: number): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: { idBrandType } });
	}

	getSearchGrid(request: TireBrandRequest): Promise<AxiosResponse<PaginationResponse<TireBrandResponse[]>, any>> {
		return api.get(`${baseRoute}/searchtirebrand`, { params: request });
	}

	saveTireBrand(request: TireBrandSaveRequest): Promise<AxiosResponse<Result<TireBrandResponse>>> {
		return api.post(`${baseRoute}/savetirebrand`, request);
	}
}
